<!-- style="width: 400px; height: 500px" -->

<style>
    .footer,
    .navbar {
        opacity: 0 !important;
    }
</style>
<pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="true"
    style="width: 100vw; height: 100vh; position: fixed; z-index: 999999;background-color: #171941;"></pdf-viewer>